import { ResponsiveLine } from '@nivo/line';
import React from 'react';
import { ChartBase } from 'src/features/boards/components/Analytics/ChartBase';

const transformData = (originalData) => {
  const transformedData: any[] = [];

  for (const key in originalData) {
    const sprintData = originalData[key];

    for (const date in sprintData.data) {
      const dayData = sprintData.data[date];
      const estimated = dayData.completed || 0;

      transformedData.push({
        date: formatDate(new Date(date)),
        estimated: estimated.toString(),
      });
    }
  }

  return transformedData;
};

const formatDate = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
};

const BurnUpChart = ({ data }: { data: any }) => {
  const dataBar = transformData(data);
  const formattedData = dataBar.map((item) => ({
    x: item.date,
    y: item.estimated,
  }));

  const chartData = [
    {
      id: 'Estimated',
      data: formattedData,
    },
  ];
  const chartObject = [
    {
      type: 'line',
      chart: (
        <ResponsiveLine
          data={chartData}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 0, max: 'auto', stacked: true, reverse: false }}
          curve="monotoneX"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            legend: 'Date',
            legendOffset: 46,
            legendPosition: 'middle',
            tickPadding: 10,
            tickRotation: 0,
            tickValues: 'every 1',
          }}
          axisLeft={{
            legend: 'Story points',
            legendOffset: -50,
            legendPosition: 'middle',
            tickPadding: 10,
            tickRotation: 0,
          }}
          colors={['#FFD321']}
          enableArea={true}
          enableGridX={false}
          enableGridY={true}
          lineWidth={3}
          enablePoints={true}
          pointSize={8}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          enableCrosshair={false}
          useMesh={true}
          animate={true}
        />
      ),
    },
  ];

  return (
    <ChartBase
      data={chartObject}
      noData={dataBar.length === 0}
      title="📈&nbsp;Burn-up for selected files"
      emptyStateTextArray={[
        'No data to show',
        'Set task estimates and fill timesheet data for accurate burn-up data',
      ]}
      // datepicker={datepicker}
      infoLabel="Calculated based on the task estimates and the timelogs recorded for each task"
    />
  );
};

export default BurnUpChart;
